import { render } from "./OnboardingBtn.vue?vue&type=template&id=6735c9c2"
import script from "./OnboardingBtn.vue?vue&type=script&lang=js"
export * from "./OnboardingBtn.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__